import { useEffect, useState } from 'react';
import api from '../../../http/api';
import KosaSkeleton from './KosaSkeleton';
import KosaView from './KosaView';
import { Kosa as IKosa } from '../../../types/kosa';

export interface KosaProps {
    id: number;
    selected: boolean;
    onClick: (id: number) => void;
}

//-------------------------------------------------------------------------------------------------
export default function Kosa({ id, selected, onClick }: KosaProps) {
    const [data, setData] = useState<IKosa | null>(null);

    useEffect(() => {
        api.get<IKosa>(`/kosa/${id}`).then((res) => setData(res.data));
    }, [id]);

    if (!data) {
        return <KosaSkeleton />;
    }

    return (
        <KosaView
            id={data.id}
            sensorCount={data.sensorCount}
            lastTransaction={data.lastTransaction}
            selected={selected}
            onClick={onClick}
        />
    );
}
